import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import store from "@/store";
import {
  required
} from "vuelidate/lib/validators";

export default {
  name: "timetableEdit",
  components: {
    MainLayout,
    Select2Multiple,
    Loading
  },

  data() {
    return {
      submitted: false,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      isLoading: false,
      academic_year: [],
      selectedClass: 0,
      class_name: "",
      classArr: [],
      class_name_required: '',
      subjectCount: [],
      subjectArr: [],
      section_exist: '',
      timeTableData: [],
      days: [],
      time: [],
      dayCount: 0,
      timeCount: 0,
      selectedSubjects: [],
      subjectRows: [],
      teacherRows: [],
      teacherOptionsByCell: {},
      teacherMap: {},
      templateArr: [],
      template_id: null,
      original_acd_year: null,
      original_class_id: null,
      original_template_id: null,
      isTemplateChanged: false,
      rows: [],
    };
  },

  computed: {
    timetableDataMap() {
      const timetableMap = {};
      if (Array.isArray(this.timeTableData)) {
        this.timeTableData.forEach(item => {
          timetableMap[item.rowColIndex] = item.subject_name;
        });
      }
      return timetableMap;
    },
  },

  validations() {
    return {
      template_id: { required }
    };
  },

  methods: {
    getSubjectByClassId(classId) {
      axios.get("/class/subjectByClassId/" + classId, {
        params: {
          acd_year_id: this.original_acd_year,
          campus_id: store.state.user.campus_id
        }
      })
        .then((response) => {
          this.subjectArr = response.data.subjectArr ? (response.data.subjectArr[0] || []) : [];
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    /**
     * Build the 2D arrays used to drive the subject/teacher dropdowns and
     * preload the teacher options for the existing subject_teacher_id values.
     */
    buildCellMaps() {
      const days = this.days || [];
      const times = this.time || [];
      this.subjectRows = Array.from({ length: days.length }, () =>
        Array.from({ length: times.length }, () => "")
      );
      this.teacherRows = Array.from({ length: days.length }, () =>
        Array.from({ length: times.length }, () => "")
      );
      this.teacherOptionsByCell = {};

      this.timeTableData.forEach((item) => {
        const rowIndex = days.findIndex(d => d.id === item.day_meta_id);
        const colIndex = times.findIndex(t => t.id === item.time_meta_id);
        if (rowIndex === -1 || colIndex === -1) return;
        if (item.subject_id) {
          this.$set(this.subjectRows[rowIndex], colIndex, item.subject_id);
        }
        if (item.subject_teacher_id) {
          this.$set(this.teacherRows[rowIndex], colIndex, item.subject_teacher_id);
          if (item.subject_id) {
            // Use the cached teacherMap and ensure the saved option is visible
            const baseOptions = this.teacherMap[item.subject_id] || [];
            const exists = baseOptions.some(o => String(o.id) === String(item.subject_teacher_id));
            const options = exists ? baseOptions : [...baseOptions, { id: item.subject_teacher_id, text: '(Saved teacher)' }];
            this.$set(this.teacherOptionsByCell, `${rowIndex}_${colIndex}`, options);
          }
        }
      });
    },

    getTeacherOptionsEdit(rowIndex, colIndex) {
      const key = `${rowIndex}_${colIndex}`;
      return this.teacherOptionsByCell[key] || [];
    },

    onSubjectChangeEdit(rowIndex, colIndex, selectedSubjectId) {
      this.$set(this.teacherRows[rowIndex], colIndex, '');
      if (!selectedSubjectId || selectedSubjectId === '0' || selectedSubjectId === 0) {
        this.$set(this.teacherOptionsByCell, `${rowIndex}_${colIndex}`, []);
        return;
      }
      this.$set(this.teacherOptionsByCell, `${rowIndex}_${colIndex}`, this.teacherMap[selectedSubjectId] || []);
    },

    changeEvent(dayId, timeId, val) {
      const itemToUpdate = this.timeTableData.find(item => item.day_meta_id === dayId && item.time_meta_id === timeId);
      if (itemToUpdate) {
        itemToUpdate.subject_teacher_id = val;
      }
    },

    update() {
      this.isLoading = true;
      this.submitted = true;

      const preparedData = [];
      for (let rowIndex = 0; rowIndex < this.days.length; rowIndex++) {
        for (let columnIndex = 0; columnIndex < this.time.length; columnIndex++) {
          const dayId = this.days[rowIndex].id;
          const timeId = this.time[columnIndex].id;
          const subjectId = this.rows[rowIndex][columnIndex];
          const rowData = {
            day_id: dayId,
            time_id: timeId,
          };
          if (subjectId !== undefined && subjectId !== null) {
            rowData.subject_id = subjectId;
          }
          preparedData.push(rowData);
        }
      }

      axios.put("/timetable/edit/" + this.original_class_id, {
        items: preparedData,
        class_id: this.original_class_id,
        template_id: this.template_id,
        original_template_id: this.original_template_id
      })
        .then(response => {
          this.isLoading = false;
          if (response.data && response.data.status == 200) {
            this.$notification.success(response.data.message || "Timetable updated successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "timetableList"
            });
          } else {
            this.$notification.error(response.data.message || "Update failed. Please try again.", {
              timer: 3,
              position: "bottomCenter"
            });
          }
        })
        .catch(error => {
          this.isLoading = false;
          console.error('Update error:', error);
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            } else {
              this.$notification.error(error.response.data.message || 'Update failed. Please try again.');
            }
          } else {
            this.$notification.error('Network error. Please try again.');
          }
        });
    },

    getTemplates() {
      this.isLoading = true;
      axios.get('/timetableMeta/templates', {
        params: {
          campus_id: store.state.user.campus_id,
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Template'
          }];
          const templates = res.data.templates.map(t => ({
            'id': t.id,
            'text': t.name
          }));
          this.templateArr = $defaultSelectOption.concat(templates);
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    changeTemplateEvent(templateId) {
      if (!templateId || templateId == 0) {
        this.timeCount = 0;
        this.dayCount = 0;
        this.days = null;
        this.time = null;
        return;
      }

      if (templateId !== this.original_template_id) {
        this.isTemplateChanged = true;
      }

      this.rows = new Array(7).fill([]).map(() => new Array(10).fill(""));
      this.isLoading = true;
      this.getTimetableMetaByTemplate(templateId);
    },

    getTimetableMetaByTemplate(templateId) {
      this.isLoading = true;
      axios.get("/timetableMeta/getDataForTimetableByTemplate/" + templateId)
        .then((response) => {
          this.days = response.data.data[0];
          this.time = response.data.data[1];
          this.dayCount = this.days.length;
          this.timeCount = this.time.length;
          
          this.selectedSubjects = Array.from({ length: this.dayCount }, () =>
            Array.from({ length: this.timeCount }, () => null)
          );
          
          this.rows = this.selectedSubjects;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getTimetableForEdit(classId) {
      this.isLoading = true;
      axios.get("/timetable/edit/" + classId)
        .then((response) => {
          if (response && response.data && response.data.status === 200) {
            const data = response.data.data;
            this.original_acd_year = data.acd_year_id;
            this.original_class_id = data.class_id;
            this.original_template_id = data.template_id;
            this.academic_year = data.period_name;
            this.class_name = data.class_name;
            this.template_id = data.template_id;
            
            this.days = data.days || [];
            this.time = data.times || [];
            this.dayCount = this.days.length;
            this.timeCount = this.time.length;

            this.getSubjectByClassId(classId);
            this.getTemplates();
            this.populateTimetableData(data.timetable);
          }
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    populateTimetableData(timetableData) {
      if (!timetableData || timetableData.length === 0) {
        this.selectedSubjects = Array.from({ length: this.dayCount }, () =>
          Array.from({ length: this.timeCount }, () => null)
        );
        this.rows = this.selectedSubjects;
        return;
      }

      const timetableMap = {};
      timetableData.forEach(item => {
        const key = `${item.day_meta_id}_${item.time_meta_id}`;
        timetableMap[key] = item.subject_id;
      });

      this.selectedSubjects = Array.from({ length: this.dayCount }, () =>
        Array.from({ length: this.timeCount }, () => null)
      );

      for (let rowIndex = 0; rowIndex < this.dayCount; rowIndex++) {
        for (let colIndex = 0; colIndex < this.timeCount; colIndex++) {
          const dayId = this.days[rowIndex]?.id;
          const timeId = this.time[colIndex]?.id;
          if (dayId && timeId) {
            const key = `${dayId}_${timeId}`;
            this.selectedSubjects[rowIndex][colIndex] = timetableMap[key] || null;
          }
        }
      }

      this.rows = this.selectedSubjects;
    },
  },

  mounted() {
    this.isLoading = true;
    const selectedClass = this.$route.params.id;
    this.getTimetableForEdit(selectedClass);
  },
};
